// extracted by mini-css-extract-plugin
module.exports = {"box":"Main_box__2Y-c1","animate":"Main_animate__D6RiY"};